import { MailIcon, PhoneIcon } from "lucide-react";
import { Link } from "react-router";

/**
 * Footer for landing pages
 */
const LandingFooter = () => {
  const footerLinkClass =
    "!text-(--brand-primary) no-underline transition-colors duration-150 hover:!text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--brand-primary) focus-visible:ring-offset-2 focus-visible:ring-offset-[#131B2A]";

  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-[#131B2A] py-14 text-white/62">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12 relative">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <Link to="/">
                <img alt="Tripbox" src="/logo_text.png" className="h-10 w-auto brightness-0 invert" />
              </Link>
            </div>
            <p className="max-w-xs text-white/62 mb-6">
              The complete operating system for modern travel agencies and DMCs.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <PhoneIcon className="w-5 h-5 text-(--brand-primary)" />
                <span className="text-white/72">+91 97697 23417</span>
              </div>
              <div className="flex items-center gap-3">
                <MailIcon className="w-5 h-5 text-(--brand-primary)" />
                <a href="mailto:contact@tripbox.com" className={footerLinkClass}>
                  contact@tripbox.com
                </a>
              </div>
            </div>
          </div>
          <div>
            <h4 className="text-white font-bold mb-6">Product</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/features" className={footerLinkClass}>
                  Features
                </Link>
              </li>
              <li>
                <Link to="/product-tour" className={footerLinkClass}>
                  Product Tour
                </Link>
              </li>
              <li>
                <Link to="/login" className={footerLinkClass}>
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/login" className={footerLinkClass}>
                  API
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold mb-6">Company</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/about" className={footerLinkClass}>
                  About
                </Link>
              </li>
              <li>
                <Link to="/login" className={footerLinkClass}>
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/login" className={footerLinkClass}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-sm">© {new Date().getFullYear()} Tripbox Inc. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className={footerLinkClass}>
              Privacy Policy
            </Link>
            <span className="text-white/20">|</span>
            <Link to="/terms-conditions" className={footerLinkClass}>
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
